import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "x_panel" };
const _hoisted_2 = { class: "x_title" };
const _hoisted_3 = { class: "nav navbar-right panel_toolbox float-end no-min-width" };
const _hoisted_4 = {
    key: 0,
    class: "x_content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
                _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Details", -1 /* CACHED */))
            ]),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createElementVNode("ul", _hoisted_3, [
                _renderSlot(_ctx.$slots, "action-menu"),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("li", null, [
                    _createElementVNode("a", {
                        class: "collapse-link",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.toggle && _ctx.toggle(...args)))
                    }, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("i", { class: "fa fa-chevron-up" }, null, -1 /* CACHED */)
                        ]))])
                ])
            ]),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clearfix" }, null, -1 /* CACHED */))
        ]),
        _cache[9] || (_cache[9] = _createTextVNode()),
        _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
                (_ctx.visible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "default"),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "spacer" }, null, -1 /* CACHED */))
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 3 /* FORWARDED */
        })
    ]));
}
